<template>
<section class="logo-grid px-4 py-16 vt:py-24 bg-secondary-600">
    <SmoothLoader class="max-w-5xl mx-auto">
        <h2 v-if="headline" class="transform -rotate-2 font-headline text-3xl vt:text-5xl font-bold mb-6 vt:mb-12 text-white text-center leading-tight" v-html="headline"></h2>
        <div class="grid gap-4">
            <div v-for="(logo, i) in logos" class="flex items-center">
                <a :href="logo.href" target="_blank" class="block p-8 flex items-center justify-center">
                    <img :src="logo.logo.src" :alt="logo.name">
                </a>
            </div>
        </div>
    </SmoothLoader>
</section>
</template>

<script>
import { ref, computed, nextTick, watch } from 'vue';

export default {
    
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>